import { render, staticRenderFns } from "./cloudcourse.vue?vue&type=template&id=0c077bc5&scoped=true"
import script from "./cloudcourse.vue?vue&type=script&lang=js"
export * from "./cloudcourse.vue?vue&type=script&lang=js"
import style0 from "./cloudcourse.vue?vue&type=style&index=0&id=0c077bc5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c077bc5",
  null
  
)

export default component.exports